export interface ICompetencyTypeItem {
    id: string;
    number: number;
    name: string;
    description: string;
    activeState: number;
}

export class CompetencyTypeItem implements ICompetencyTypeItem {
    id: string;
    number: number;
    name: string;
    description: string;
    activeState: number;

    constructor();
    constructor(obj: ICompetencyTypeItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.number = obj && obj.number || 0;
        this.name = obj && obj.name || "";
        this.description = obj && obj.description || "";
        this.activeState = obj && obj.activeState || 0;
    }
}